import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=3c5eb626&scoped=true&slot-scope=scope&"
import script from "./DueDate.vue?vue&type=script&lang=js&"
export * from "./DueDate.vue?vue&type=script&lang=js&"
import style0 from "./DueDate.vue?vue&type=style&index=0&id=3c5eb626&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5eb626",
  null
  
)

export default component.exports